import axios from 'axios';

const HTTP = axios.create({});

export default HTTP;
